import * as React from 'react'

import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  filename?: string
  placeholder: string
}

const DocumentText = ({ filename, placeholder }: Props) => {
  return filename ? (
    <Box alignItems="center" gap="s12">
      <Icon.Large icon="document-edit" />
      <Text.Normal>{filename}</Text.Normal>
    </Box>
  ) : (
    <Text.Normal>{placeholder}</Text.Normal>
  )
}

export default observer(DocumentText)
